import {React , useEffect} from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
// import BlogArea from './components/Home/BlogArea';
//import BrandArea from './components/Home/BrandArea';
// import FeatureArea from './components/Home/FeatureArea';
// import FeaturesFA from './components/Home/FeaturesFA';
// import SDBanner from './components/Home/SdBanner';
// import ProcessArea from './components/Home/ProcessArea';
// import ServicesArea from './components/Home/ServicesArea';
// import TeamArea from './components/Home/TeamArea';
// import Testimonial from './components/Home/Testimonial';
import Home   from './pages/Home';
import Contact from './pages/contact';
import About from './pages/about';
import Solution from './pages/solution';
import Politique from './pages/Politique';
// import EagleVision from "./pages/eagle-vision";
import ProductDetails from './pages/product-details';
import './assets/scss/main.scss';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useRef } from 'react';
import { LanguageProvider,  } from './contexts/LanguageContext';
import CookieBanner from './components/common/CookieBanner';


const ScrollManager = () => {
  const location = useLocation();
  const lastPathRef = useRef('');

  useEffect(() => {
    const { pathname, hash } = location;


    // Avoid duplicate work if path unchanged (only hash change allowed)
    if (lastPathRef.current === pathname && hash) return;
    lastPathRef.current = pathname;

    // If there is a hash (#about), let the target section logic handle smooth scroll
    if (hash) return;

   
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location]);

  return null;
};

const App = () => {
  return (
     <>
         <LanguageProvider>

    <ScrollManager />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Solution />} />
        <Route path="/products/:slug" element={<ProductDetails />} />
        <Route path="/Politique_de_confidentialité" element={<Politique />} />
        
      </Routes>
    <ToastContainer
      position="bottom-right"
      autoClose={5000}
      theme="light"
      newestOnTop
      style={{ zIndex: 2147483647 }}
    />
    <CookieBanner />
        </LanguageProvider>

    </>
);
};

export default App;
